import rings from '../assets/images/categories/rings.jpg';
import earrings from '../assets/images/categories/earrings.jpg';
import necklace from '../assets/images/categories/necklace.jpg';
import bangles from '../assets/images/categories/bangles.jpg';
import bracelet from '../assets/images/categories/bracelet.jpg';
import solitaire from '../assets/images/categories/solitaire.jpg';
import mangalsutra from '../assets/images/categories/mangalsutra.jpg';
import otherJewellery from '../assets/images/categories/otherJewellery.jpg';
import gift from '../assets/images/categories/gift.jpg';

export const productCategories = [
    {
        identifier: 'rings',
        title: 'Rings',
        image: rings,
        count: '280 Styles',
        value: '583'
    },
    {
        identifier: 'earrings',
        title: 'Earrings',
        image: earrings,
        count: '280 Styles',
        value: '584'
    },
    {
        identifier: 'necklace',
        title: 'Necklace',
        image: necklace,
        count: '280 Styles',
        value: '682'
    },
    {
        identifier: 'bangles',
        title: 'Bangles',
        image: bangles,
        count: '280 Styles',
        value: '586'
    },
    {
        identifier: 'bracelet',
        title: 'Bracelet',
        image: bracelet,
        count: '280 Styles',
        value: '591'
    },
    {
        identifier: 'solitaire',
        title: 'Solitaire',
        image: solitaire,
        count: '280 Styles',
        value: '1579'
    },
    {
        identifier: 'mangalsutra',
        title: 'Mangalsutra',
        image: mangalsutra,
        count: '280 Styles',
        value: '1057'
    },
    {
        identifier: 'otherJewellery',
        title: 'Other Jewellery',
        image: otherJewellery,
        count: '280 Styles',
        value: '1890'
    },
    {
        identifier: 'gift',
        title: 'Gift',
        image: gift,
        count: '280 Styles',
        value: '985'
    },
]